import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../Button/Button';

import './styles.css';

const ContentCampaignBanner = ({ item }) => {
  const history = useHistory();

  const handleClickDetail = () => {
    history.push(`/campaign/${item.id}`);
  };

  return (
    <div className='item-detail'>
      <div className='title' data-item='campaign' onClick={handleClickDetail}>
        {item.props.header}
      </div>
      <div className='content-actions'>
        <Button
          iconStyle={{
            width: 40,
            height: 40,
            backgroundColor: '#F49832',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
          }}
          shape='rounded'
          fontSize={16}
          size='large'
          width={224}
          style={{
            height: '40px',
            fontWeight: 'bold',
          }}
          onClick={handleClickDetail}
        >
          Read More
        </Button>
      </div>
    </div>
  );
};

export default ContentCampaignBanner;
